import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { QUICK_SHIP_DELIVERY_ESTIMATES, isQuickShip } from '@/common/QuickShip';

const estimatedDateFormat = 'MMM dd';

/**
 * Hook that calculates estimated delivery date based on the product model.
 * @param product - the product model object.
 * @param baseEstimatedDeliveryDate if there is a previous estimate delivery date, it will be used as the base date.
 * @returns {{estimatedStartDate: string, estimatedEndDate: string}}
 */
export default function useEstimatedDeliveryDate(
  product,
  baseEstimatedDeliveryDate = null
) {
  const [estimatedStartDate, setEstimatedStartDate] = useState('');
  const [estimatedEndDate, setEstimatedEndDate] = useState('');

  const { leadTime, shippingWindow } = getLeadTimes(product);

  const estimatedDeliveryDate = baseEstimatedDeliveryDate
    ? DateTime.fromISO(baseEstimatedDeliveryDate)
    : DateTime.now().plus({ days: leadTime });

  useEffect(() => {
    formatStartDate(estimatedDeliveryDate);
    formatEndDate(estimatedDeliveryDate);
  }, [estimatedDeliveryDate, shippingWindow]);

  const formatStartDate = date =>
    setEstimatedStartDate(date.toFormat(estimatedDateFormat));

  const formatEndDate = date =>
    setEstimatedEndDate(
      date.plus({ days: shippingWindow }).toFormat(estimatedDateFormat)
    );

  return {
    estimatedStartDate,
    estimatedEndDate
  };
}

function getLeadTimes(product) {
  const leadTime = isQuickShip(product)
    ? QUICK_SHIP_DELIVERY_ESTIMATES.leadTime
    : product.lead_time;

  const shippingWindow = isQuickShip(product)
    ? QUICK_SHIP_DELIVERY_ESTIMATES.shippingWindow
    : product.shipping_window;

  return {
    leadTime,
    shippingWindow
  };
}
